import {
    $getSelection, $isRangeSelection,
    COMMAND_PRIORITY_LOW,
    createCommand,
    LexicalNode
} from "lexical"
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext"
import {$setBlocksType} from "@lexical/selection"
import {BannerNode} from "./node/banner-node"

export enum BannerType {
    LIGHT_BLUE  = 'banner-light-blue',
    DARK_BLUE   = 'banner-dark-blue',
    GREEN       = 'banner-green',
    YELLOW      = 'banner-yellow',
    ORANGE      = 'banner-orange',
    RED         = 'banner-red',
    MAGENTA     = 'banner-magenta',
    PURPLE      = 'banner-purple',
    BROWN       = 'banner-brown',
    GRAY        = 'banner-gray',
}

export const INSERT_BANNER_COMMAND = createCommand<BannerType>('insertBanner')

export function BannerPlugin(): null {

    const [editor] = useLexicalComposerContext()
    // check if node is added to config and show warning if not
    if (!editor.hasNodes([BannerNode])) {
        throw new Error('BannerPlugin: BannerNode is not registered on editor')
    }

    editor.registerCommand(INSERT_BANNER_COMMAND, (value: BannerType) => {
        editor.update(() => {
            let selection = $getSelection();

            if ($isRangeSelection(selection)) {
                if (selection.isCollapsed()) {
                    $setBlocksType(selection, () => $createBannerNode(value));
                } else {
                    const textContent = selection.getTextContent();
                    const codeNode = $createBannerNode(value);
                    selection.insertNodes([codeNode]);
                    selection = $getSelection();
                    if ($isRangeSelection(selection))
                        selection.insertRawText(textContent);
                }
            }
        })

        /*const selection = $getSelection()
        if ($isRangeSelection(selection)) {
            $setBlocksType(selection, () => $createBannerNode(value))
        }*/
        return true // true to stop propagate this command
    }, COMMAND_PRIORITY_LOW)

    return null
}

// lexical convention function
export function $createBannerNode(type: BannerType): BannerNode {
    return new BannerNode(type)
}

// lexical convention function
export function $isBannerNode(node:LexicalNode): node is BannerNode {
    return node instanceof BannerNode
}